import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import CustomSizeList from "./customSize/CustomSizeList";
import CustomSizeSwapButton from "./customSize/CustomSizeSwapButton";
import Switcher from "../../../ui/Switcher";
import sqftShape from "../../../canvas/core/shapes/sqftShape";
import ConfirmButtons from "./ConfirmButtons";
import { is3DMode } from "../../NavigationHelper";
import {reloadCountertopsIn3DMode, reloadShapesIn3DMode} from "../../../../helpers/3dHelper/modelsHelper";

const SectionCustomSize = (props) => {
  const { shape } = props;
  const [isEnabled, setEnabled] = useState(shape.shouldAddCabinetBox);
  const [listKey, setCustomSizeListKey] = useState(0);
  const [isProcessing, setProcessing] = useState(false);

  const onChange = () => {
    setEnabled(!isEnabled);
  };

  const initialShapeDimensions = {
    width:  shape.getWidth(),
    height: shape.getHeight(),
    depth:  shape.getDepth(),
  };

  const confirmCallback = async () => {
    if (isProcessing) return;
    setProcessing(true);
    try {
      await reloadShapesIn3DMode([shape]);
      await reloadCountertopsIn3DMode([shape]);
    } finally {
      setProcessing(false);
    }
  };

  const cancelCallback = async () => {
    if (isProcessing) return;
    shape.setHeight(initialShapeDimensions.height);
    shape.setDepth(initialShapeDimensions.depth);
    shape.setWidth(initialShapeDimensions.width);

    setProcessing(true);
    try {
      await reloadShapesIn3DMode([shape]);
      await reloadCountertopsIn3DMode([shape]);
      setCustomSizeListKey(prev => prev + 1);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="sr__section sr__custom-size">
      <div className="sr__section-title">
        Enable Custom Size
        <span>
          <Switcher value={isEnabled} onChange={onChange} />
        </span>
      </div>

      <CustomSizeList
        listKey={listKey}
        shape={shape}
        isEnabled={isEnabled}
      />

      {is3DMode() && isEnabled && (
        <div
          style={{
            pointerEvents: isProcessing ? 'none' : 'auto',
            opacity:        isProcessing ? 0.6      : 1,
            transition:     'opacity 0.2s'
          }}
        >
          <ConfirmButtons
            confirmCallback={confirmCallback}
            cancelCallback={cancelCallback}
            isLoading={isProcessing}
          />
        </div>
      )}

      <CustomSizeSwapButton shape={shape} />
    </div>
  );
};

SectionCustomSize.propTypes = {
  shape: PropTypes.instanceOf(sqftShape).isRequired,
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SectionCustomSize);
